// @mui material components
import Grid from "@mui/material/Grid";

// Material Dashboard 3 PRO React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDAvatar from "components/MDAvatar";
import MDButton from "components/MDButton";

// Wizard application components
import FormField from "layouts/applications/wizard/components/FormField";

// Images
import team2 from "assets/images/team-2.jpg";

function About() {
  return (
    <MDBox>
      <MDBox width="82%" textAlign="center" mx="auto" my={4}>
        <MDBox mb={1}>
          <MDTypography variant="h5" fontWeight="regular">
          </MDTypography>
        </MDBox>
        <MDTypography variant="body2" color="text">
        This RoBERTa model is fine-tuned on 8 million social media posts from X (formerly Twitter). It achieves an accuracy of over 88% in detecting sentiment related to solar energy, categorized as positive, neutral, or negative. The model effectively distinguishes between personal messages and commercial content about solar energy. For more details, please refer to the publication below.
        </MDTypography>
      </MDBox>
      <MDBox mt={2}>
        <Grid container spacing={3}>
        </Grid>
      </MDBox>
    </MDBox>
  );
}

export default About;
